<template>
  <div class="name">

    <!-- <el-row class="bgW">
      <el-col :span="20">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="产品名称">
            <el-input
              v-model="search.name"
              maxlength="30"
              clearable
              placeholder="请输入产品名称"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" clearable placeholder="请选择状态">
              <el-option
                v-for="item in options.statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button type="primary" size="mini" @click="getList('resetForm')">重置</el-button>
      </el-col>
    </el-row> -->
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog">添加</el-button>
    </div>
    <div class="accountCon">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="编号" width="55" >
              <template slot-scope="{ row }">
                {{ row.scar}}{{ row.acne}}{{ row.sclererythrin}}{{ row.color_stain}}{{ row.wrinkle }}
              </template>
            </el-table-column>
            <el-table-column label="敏感" width="80" align="center">
              <template slot-scope="{ row }">
                {{ row.scar_speed || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="痤疮" width="80" align="center">
              <template slot-scope="{ row }">
                {{ row.acne_speed || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="紫质" width="80" align="center">
              <template slot-scope="{ row }">
                {{ row.sclererythrin_speed || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="色斑" width="80" align="center">
              <template slot-scope="{ row }">
                {{ row.color_stain_speed || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="皱纹" width="80" align="center">
              <template slot-scope="{ row }">
                {{ row.wrinkle_speed || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="精粹水" prop="treatment_lotion" min-width="120" show-overflow-tooltip />
            <el-table-column label="面霜" prop="face_cream" min-width="120" show-overflow-tooltip />
            <el-table-column label="品项" prop="product_item" min-width="120" show-overflow-tooltip />
            <el-table-column label="复合组合" min-width="120" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.product_name || (row.custom_product_id || '-') }}
              </template>
            </el-table-column>
            <el-table-column label="状态" width="140" align="center">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="handleStatusChange(row)"
                />
              </template>
            </el-table-column>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="新增五维三度"
      :visible.sync="dialogVisible"
      width="640px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form label-width="110px" size="small">
        <el-row>
          <el-col :span="7">
            <el-form-item label="敏感：">
              <el-select v-model="form.scar" class="dim-select">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="痤疮：">
              <el-select v-model="form.acne" class="dim-select">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="紫质：">
              <el-select v-model="form.sclererythrin" class="dim-select">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="色斑：">
              <el-select v-model="form.color_stain" class="dim-select">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="皱纹：">
              <el-select v-model="form.wrinkle" class="dim-select">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="复合组合：" required>
              <el-select
                v-model="form.custom_product_id"
                filterable
                remote
                clearable
                :remote-method="searchProduct"
                :loading="productLoading"
                placeholder="输入名称搜索复合组合"
                class="product-select"
              >
                <el-option
                  v-for="item in productOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          
          <el-col :span="20">
            <el-form-item label="品项组合：">
              <el-input v-model="form.product_item" type="textarea" placeholder="请输入品项" />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="精粹水：">
              <el-input v-model="form.treatment_lotion" type="textarea" placeholder="请输入精粹水" />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="面霜：">
              <el-input v-model="form.face_cream"  type="textarea" placeholder="请输入面霜" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { getFiveThreeList, selectProductList, createFiveThree, updateFiveThreeStatus } from '@/api/goods'

class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}
class Search {
  product_name = '';
  status = '';
}
export default {
  name: 'FinalGroupList',
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      list: [],
      dialogVisible: false,
      productLoading: false,
      productOptions: [],
      levelList: [
        { label: '无', value: 0 },
        { label: '轻度', value: 1 },
        { label: '中度', value: 2 },
        { label: '重度', value: 3 }
      ],
      form: {
        scar: 0,
        acne: 0,
        sclererythrin: 0,
        color_stain: 0,
        wrinkle: 0,
        product_item: '',
        treatment_lotion: '',
        face_cream: '',
        custom_product_id: null
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(option) {
      if (option === 'resetForm') { this.search = new Search(); this.page = new Page(); }
      if (option === 'search') this.page = new Page();
      getFiveThreeList({ ...this.search, ...this.page }).then(res => {
        this.list = res.data.list;
        this.page.total = res.data.dataCount;
      });
    },
    handleStatusChange(row) {
       updateFiveThreeStatus({ id: row.id, status: row.status }).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        });
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1;
      });
    },
    // 打开新增弹窗
    openDialog() {
      this.dialogVisible = true;
      this.resetForm();
      this.searchProduct('');
    },
    // 关闭弹窗重置表单
    resetForm() {
      this.form = {
        scar: 0,
        acne: 0,
        sclererythrin: 0,
        color_stain: 0,
        wrinkle: 0,
        product_item: '',
        treatment_lotion: '',
        face_cream: '',
        custom_product_id: null
      };
      this.productOptions = [];
    },
    // 远程搜索复合组合
    searchProduct(query) {
      this.productLoading = true;
      selectProductList({ name: query, is_select: 1 }).then(res => {
        this.productOptions = (res.data && res.data.list) || [];
        this.productLoading = false;
      }).catch(() => { this.productLoading = false; });
    },
    // 保存
    submitForm() {
      const f = this.form;
      if (!f.custom_product_id) {
        return this.$message.warning('请选择复合组合');
      }
      createFiveThree({
        scar: f.scar,
        acne: f.acne,
        sclererythrin: f.sclererythrin,
        color_stain: f.color_stain,
        wrinkle: f.wrinkle,
        product_item: f.product_item,
        treatment_lotion: f.treatment_lotion,
        face_cream: f.face_cream,
        custom_product_id: f.custom_product_id || 0
      }).then(res => {
        this.$message({ type: 'success', message: res.msg || '添加成功' });
        this.dialogVisible = false;
        this.getList('search');
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.accountCon {
  background: #fff;
  padding: 10px 0 80px;
}
.compound-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 12px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
  .form-item {
    display: flex;
    align-items: center;
    .form-label {
      font-size: 13px;
      color: #606266;
      font-weight: 600;
      margin-right: 6px;
    }
    .header-price {
      width: 120px;
    }
    .header-remark {
      width: 260px;
    }
  }
}
.compound-wrap {
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 6px;
}
.tube-block {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  .tube-head {
    margin-bottom: 10px;
    .tube-name {
      font-weight: 600;
      font-size: 14px;
      color: #303133;
    }
  }
  .tube-table {
    margin-bottom: 6px;
    .select-inline {
      width: 200px;
    }
    .qty-inline {
      width: 100px;
    }
  }
}
.header-center {
  text-align: center !important;
}
.dim-tag {
  display: inline-block;
  margin-left: 4px;
  padding: 0 4px;
  font-size: 11px;
  color: #909399;
  background: #f0f2f5;
  border-radius: 2px;
}
.dim-select {
  width: 110px;
}
.product-select {
  width: 100%;
}
</style>
